export type DestinationOption = { value: string; label: string };

// Shared list used by trip create/edit flows for popular destinations.
// Note: `label` is also used as the stored destination string.
export const DESTINATION_OPTIONS: DestinationOption[] = [
  // Core popular destinations
  { value: 'lisbon', label: 'Lisbon, Portugal' },
  { value: 'paris', label: 'Paris, France' },
  { value: 'london', label: 'London, UK' },
  { value: 'rome', label: 'Rome, Italy' },
  { value: 'barcelona', label: 'Barcelona, Spain' },
  { value: 'amsterdam', label: 'Amsterdam, Netherlands' },
  { value: 'berlin', label: 'Berlin, Germany' },
  { value: 'prague', label: 'Prague, Czech Republic' },
  { value: 'vienna', label: 'Vienna, Austria' },
  { value: 'athens', label: 'Athens, Greece' },
  { value: 'dubai', label: 'Dubai, UAE' },
  { value: 'tokyo', label: 'Tokyo, Japan' },
  { value: 'kyoto', label: 'Kyoto, Japan' },
  { value: 'seoul', label: 'Seoul, South Korea' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'bangkok', label: 'Bangkok, Thailand' },
  { value: 'bali', label: 'Bali, Indonesia' },
  { value: 'sydney', label: 'Sydney, Australia' },
  { value: 'melbourne', label: 'Melbourne, Australia' },
  { value: 'new-york', label: 'New York, USA' },
  { value: 'los-angeles', label: 'Los Angeles, USA' },
  { value: 'san-francisco', label: 'San Francisco, USA' },
  { value: 'miami', label: 'Miami, USA' },
  { value: 'chicago', label: 'Chicago, USA' },
  { value: 'toronto', label: 'Toronto, Canada' },
  { value: 'vancouver', label: 'Vancouver, Canada' },
  { value: 'mexico-city', label: 'Mexico City, Mexico' },
  { value: 'rio-de-janeiro', label: 'Rio de Janeiro, Brazil' },
  { value: 'buenos-aires', label: 'Buenos Aires, Argentina' },
  { value: 'cape-town', label: 'Cape Town, South Africa' },
  { value: 'marrakech', label: 'Marrakech, Morocco' },
  { value: 'cairo', label: 'Cairo, Egypt' },
  { value: 'istanbul', label: 'Istanbul, Turkey' },
  { value: 'cappadocia', label: 'Cappadocia, Turkey' },
  { value: 'mumbai', label: 'Mumbai, India' },
  { value: 'delhi', label: 'Delhi, India' },
  { value: 'hong-kong', label: 'Hong Kong' },
  { value: 'shanghai', label: 'Shanghai, China' },
  { value: 'beijing', label: 'Beijing, China' },
  // Canada (adds less-popular options)
  { value: 'ottawa', label: 'Ottawa, Canada' },
  { value: 'calgary', label: 'Calgary, Canada' },
  { value: 'edmonton', label: 'Edmonton, Canada' },
  { value: 'quebec-city', label: 'Quebec City, Canada' },
  { value: 'halifax', label: 'Halifax, Canada' },
  { value: 'winnipeg', label: 'Winnipeg, Canada' },
  // USA mid-size and regional hubs
  { value: 'boston', label: 'Boston, USA' },
  { value: 'seattle', label: 'Seattle, USA' },
  { value: 'denver', label: 'Denver, USA' },
  { value: 'portland', label: 'Portland, USA' },
  { value: 'austin', label: 'Austin, USA' },
  { value: 'nashville', label: 'Nashville, USA' },
  { value: 'phoenix', label: 'Phoenix, USA' },
  { value: 'tucson', label: 'Tucson, Arizona, USA' },
  { value: 'salt-lake-city', label: 'Salt Lake City, USA' },
  { value: 'dallas', label: 'Dallas, USA' },
  { value: 'houston', label: 'Houston, USA' },
  { value: 'atlanta', label: 'Atlanta, USA' },
  { value: 'san-diego', label: 'San Diego, USA' },
  { value: 'san-antonio', label: 'San Antonio, USA' },
  { value: 'springfield-il', label: 'Springfield, Illinois, USA' },
  { value: 'springfield-ma', label: 'Springfield, Massachusetts, USA' },
  { value: 'san-jose-usa', label: 'San Jose, California, USA' },
  // UK & Ireland (beyond London)
  { value: 'manchester', label: 'Manchester, UK' },
  { value: 'edinburgh', label: 'Edinburgh, UK' },
  { value: 'glasgow', label: 'Glasgow, UK' },
  { value: 'birmingham-uk', label: 'Birmingham, UK' },
  { value: 'liverpool', label: 'Liverpool, UK' },
  { value: 'belfast', label: 'Belfast, UK' },
  { value: 'cardiff', label: 'Cardiff, UK' },
  { value: 'dublin', label: 'Dublin, Ireland' },
  // Western Europe (second-tier cities)
  { value: 'porto', label: 'Porto, Portugal' },
  { value: 'valencia', label: 'Valencia, Spain' },
  { value: 'seville', label: 'Seville, Spain' },
  { value: 'granada', label: 'Granada, Spain' },
  { value: 'nice', label: 'Nice, France' },
  { value: 'lyon', label: 'Lyon, France' },
  { value: 'marseille', label: 'Marseille, France' },
  { value: 'brussels', label: 'Brussels, Belgium' },
  { value: 'antwerp', label: 'Antwerp, Belgium' },
  { value: 'munich', label: 'Munich, Germany' },
  { value: 'hamburg', label: 'Hamburg, Germany' },
  { value: 'frankfurt', label: 'Frankfurt, Germany' },
  { value: 'cologne', label: 'Cologne, Germany' },
  { value: 'zurich', label: 'Zurich, Switzerland' },
  { value: 'geneva', label: 'Geneva, Switzerland' },
  { value: 'copenhagen', label: 'Copenhagen, Denmark' },
  { value: 'stockholm', label: 'Stockholm, Sweden' },
  { value: 'oslo', label: 'Oslo, Norway' },
  { value: 'helsinki', label: 'Helsinki, Finland' },
  { value: 'reykjavik', label: 'Reykjavik, Iceland' },
  // Central & Eastern Europe
  { value: 'budapest', label: 'Budapest, Hungary' },
  { value: 'krakow', label: 'Krakow, Poland' },
  { value: 'warsaw', label: 'Warsaw, Poland' },
  { value: 'bucharest', label: 'Bucharest, Romania' },
  { value: 'sofia', label: 'Sofia, Bulgaria' },
  { value: 'belgrade', label: 'Belgrade, Serbia' },
  { value: 'sarajevo', label: 'Sarajevo, Bosnia and Herzegovina' },
  { value: 'zagreb', label: 'Zagreb, Croatia' },
  { value: 'ljubljana', label: 'Ljubljana, Slovenia' },
  { value: 'tbilisi', label: 'Tbilisi, Georgia' },
  { value: 'riga', label: 'Riga, Latvia' },
  { value: 'vilnius', label: 'Vilnius, Lithuania' },
  { value: 'tallinn', label: 'Tallinn, Estonia' },
  { value: 'kyiv', label: 'Kyiv, Ukraine' },
  // Middle East & North Africa
  { value: 'doha', label: 'Doha, Qatar' },
  { value: 'muscat', label: 'Muscat, Oman' },
  { value: 'amman', label: 'Amman, Jordan' },
  { value: 'tel-aviv', label: 'Tel Aviv, Israel' },
  { value: 'jerusalem', label: 'Jerusalem, Israel' },
  { value: 'riyadh', label: 'Riyadh, Saudi Arabia' },
  { value: 'jeddah', label: 'Jeddah, Saudi Arabia' },
  { value: 'beirut', label: 'Beirut, Lebanon' },
  { value: 'casablanca', label: 'Casablanca, Morocco' },
  // Africa (broader coverage)
  { value: 'nairobi', label: 'Nairobi, Kenya' },
  { value: 'mombasa', label: 'Mombasa, Kenya' },
  { value: 'kigali', label: 'Kigali, Rwanda' },
  { value: 'accra', label: 'Accra, Ghana' },
  { value: 'lagos', label: 'Lagos, Nigeria' },
  { value: 'abuja', label: 'Abuja, Nigeria' },
  { value: 'dar-es-salaam', label: 'Dar es Salaam, Tanzania' },
  { value: 'zanzibar', label: 'Zanzibar, Tanzania' },
  { value: 'addis-ababa', label: 'Addis Ababa, Ethiopia' },
  { value: 'victoria-falls', label: 'Victoria Falls, Zimbabwe' },
  // South & Central Asia
  { value: 'bengaluru', label: 'Bengaluru, India' },
  { value: 'chennai', label: 'Chennai, India' },
  { value: 'kolkata', label: 'Kolkata, India' },
  { value: 'jaipur', label: 'Jaipur, India' },
  { value: 'hyderabad', label: 'Hyderabad, India' },
  { value: 'ahmedabad', label: 'Ahmedabad, India' },
  { value: 'lahore', label: 'Lahore, Pakistan' },
  { value: 'karachi', label: 'Karachi, Pakistan' },
  { value: 'islamabad', label: 'Islamabad, Pakistan' },
  { value: 'kathmandu', label: 'Kathmandu, Nepal' },
  { value: 'colombo', label: 'Colombo, Sri Lanka' },
  // East & Southeast Asia
  { value: 'taipei', label: 'Taipei, Taiwan' },
  { value: 'kaohsiung', label: 'Kaohsiung, Taiwan' },
  { value: 'kuala-lumpur', label: 'Kuala Lumpur, Malaysia' },
  { value: 'penang', label: 'Penang, Malaysia' },
  { value: 'manila', label: 'Manila, Philippines' },
  { value: 'cebu', label: 'Cebu, Philippines' },
  { value: 'chiang-mai', label: 'Chiang Mai, Thailand' },
  { value: 'da-nang', label: 'Da Nang, Vietnam' },
  { value: 'hoi-an', label: 'Hoi An, Vietnam' },
  { value: 'hanoi', label: 'Hanoi, Vietnam' },
  { value: 'ho-chi-minh', label: 'Ho Chi Minh City, Vietnam' },
  { value: 'taiyuan', label: 'Taiyuan, China' },
  { value: 'chengdu', label: 'Chengdu, China' },
  { value: 'shenzhen', label: 'Shenzhen, China' },
  // Oceania
  { value: 'brisbane', label: 'Brisbane, Australia' },
  { value: 'perth', label: 'Perth, Australia' },
  { value: 'adelaide', label: 'Adelaide, Australia' },
  { value: 'auckland', label: 'Auckland, New Zealand' },
  { value: 'wellington', label: 'Wellington, New Zealand' },
  // Latin America
  { value: 'bogota', label: 'Bogota, Colombia' },
  { value: 'medellin', label: 'Medellin, Colombia' },
  { value: 'cartagena', label: 'Cartagena, Colombia' },
  { value: 'quito', label: 'Quito, Ecuador' },
  { value: 'lima', label: 'Lima, Peru' },
  { value: 'cusco', label: 'Cusco, Peru' },
  { value: 'santiago', label: 'Santiago, Chile' },
  { value: 'valparaiso', label: 'Valparaiso, Chile' },
  { value: 'montevideo', label: 'Montevideo, Uruguay' },
  { value: 'panama-city', label: 'Panama City, Panama' },
  { value: 'san-jose-cr', label: 'San Jose, Costa Rica' },
  // Existing fallback
  { value: 'other', label: 'Other (custom)' },
];

export function findDestinationLabel(value: string): string | undefined {
  return DESTINATION_OPTIONS.find((opt) => opt.value === value)?.label;
}


